module.exports = __webpack_public_path__ + "static/media/product_use_case_4.421a8ddf.svg";